import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import PlText from './PlText';
var PlSidebarHeader = function (_a) {
    var title = _a.title, _b = _a.className, className = _b === void 0 ? '' : _b, leftComponent = _a.leftComponent, rightComponent = _a.rightComponent;
    return (_jsxs("div", { className: "flex flex-row justify-between items-center px-8 border-b py-4 ".concat(className), children: [_jsx("div", { className: "w-24", children: leftComponent }), title && _jsx(PlText, { className: "font-medium", label: title }), _jsx("div", { className: "w-24 flex justify-end", children: rightComponent })] }));
};
export default PlSidebarHeader;
